import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { tap } from 'rxjs/operators';

import {
    PresentationView,
    PresentationViewOpts,
} from './presentation.insight.model';

@Component({
    selector: '[cmpsInsightPresentation]',
    templateUrl: './presentation.insight.component.html',
})
export class PresentationInsightComponent implements OnChanges, OnInit {
    @Input() selection: PresentationView;
    @Output() selectionChange: EventEmitter<PresentationView>;
    PresentationViewOpts = PresentationViewOpts;
    form: FormGroup;

    constructor(private readonly _formBuilder: FormBuilder) {
        this.selectionChange = new EventEmitter();

        this.form = this._formBuilder.group({
            which: [null],
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        // eslint-disable-next-line no-prototype-builtins
        if (changes.hasOwnProperty('selection')) {
            this.form.patchValue(
                {
                    which: this.selection,
                },
                { emitEvent: false },
            );
        }
    }

    ngOnInit(): void {
        // TODO unsub
        this.form
            .get('which')
            .valueChanges.pipe(tap((value) => this.selectionChange.emit(value)))
            .subscribe();
    }
}
